import ContentBody from '@op/components/ContentBody';
import React, { useMemo } from 'react';
import { Layout, Tabs } from 'tea-component';
import { getLocale } from 'umi';
import CardSlot from '@/pages/intelligence/components/CardSlot';
// @ts-nocheck
import advanced_zh from './advanced_summary_zh.md';
import advanced_en from './advanced_summary_en.md';
import common_en from './common_summary_en.md';
import common_zh from './common_summary_zh.md';
import deepseek_common_en from './deepseek_common_summary_en.md';
import deepseek_common_cn from './deepseek_common_summary_zh.md';
import deepseek_advanced_en from './deepseek_advanced_summary_en.md';
import deepseek_advanced_zh from './deepseek_advanced_summary_zh.md';
import gemini_common_en from './gemini_common_summary_en.md';
import gemini_common_cn from './gemini_common_summary_zh.md';
import gemini_advanced_en from './gemini_advanced_summary_en.md';
import gemini_advanced_zh from './gemini_advanced_summary_zh.md';

import MDShow from '../components/mdShow';
import './index.scss';
import { LocaleType } from '@op/types/common';
import {
  AI_MODAL_OPTIONS,
  AiIconMap,
  DEFAULT_MODAL,
  gptOptionsTextMap,
} from '@op/components/GPT/constants';
import useTabHistory from '@op/hooks/useTabHistory';
import { GPTType } from '@op/components/GPT/types';
import useLanguage from '@op/hooks/useLanguage';

const { Body, Content } = Layout;

const advancedMdMap: { [key: string]: string } = {
  'en-US': advanced_en,
  'zh-CN': advanced_zh,
};
const commonMdMap: { [key: string]: string } = {
  'en-US': common_en,
  'zh-CN': common_zh,
};

const deepseekAdvancedMdMap: { [key: string]: string } = {
  'en-US': deepseek_advanced_en,
  'zh-CN': deepseek_advanced_zh,
};

const deepseekCommonMdMap: { [key: string]: string } = {
  'en-US': deepseek_common_en,
  'zh-CN': deepseek_common_cn,
};

const geminiAdvancedMdMap: { [key: string]: string } = {
  'en-US': gemini_advanced_en,
  'zh-CN': gemini_advanced_zh,
};

const geminiCommonMdMap: { [key: string]: string } = {
  'en-US': gemini_common_en,
  'zh-CN': gemini_common_cn,
};

const GPTSummaryDemoConfig = [
  {
    title: gptOptionsTextMap.basic,
    desc: [
      {
        'en-US':
          "Provides a quick and concise overview of opinions, summarizing the main positive and negative feedback points. This will help operations intuitively understand the players' attitudes.",
        'zh-CN':
          '提供快速且简洁的舆情概述，将总结出主要的正面和负面反馈要点，帮助运营直观获取玩家态度。',
      },
    ],
    mdFileMap: commonMdMap,
  },
  {
    title: gptOptionsTextMap.advanced,
    desc: [
      {
        'en-US':
          'Provides detailed opinion summary on positive and negative player feedback, supplemented with specific data statistics. Each opinion will display the number of player comments and engagement data (such as likes).',
        'zh-CN':
          '提供正面、负面玩家反馈的详细观点，并附加具体的观点数据统计。每个观点都将展示玩家的具体评论数及互动数据（如点赞数）。',
      },
      {
        'en-US':
          'To ensure the effectiveness of the summary, neutral and invalid comments are not analyzed by default.',
        'zh-CN': '为保证总结的有效性，我们默认会对所选数据进行两个处理：',
      },
      {
        'en-US': '',
        'zh-CN': '1. 去除中性评论（暂不支持）',
      },
      {
        'en-US': '',
        'zh-CN': '2. 去除被DataBrain判定为无效的评论',
      },
    ],
    mdFileMap: advancedMdMap,
  },
];

const geminiSummaryDemoConfig = [
  {
    title: gptOptionsTextMap.basic,
    desc: [
      {
        'en-US':
          "Provides a quick and concise overview of opinions, summarizing the main positive and negative feedback points. This will help operations intuitively understand the players' attitudes.",
        'zh-CN':
          '提供快速且简洁的舆情概述，将总结出主要的正面和负面反馈要点，帮助运营直观获取玩家态度。',
      },
    ],
    mdFileMap: geminiCommonMdMap,
  },
  {
    title: gptOptionsTextMap.advanced,
    desc: [
      {
        'en-US':
          'Provides detailed opinion summary on positive and negative player feedback, supplemented with specific data statistics. Each opinion will display the number of player comments and engagement data (such as likes).',
        'zh-CN':
          '提供正面、负面玩家反馈的详细观点，并附加具体的观点数据统计。每个观点都将展示玩家的具体评论数及互动数据（如点赞数）。',
      },
      {
        'en-US':
          'To ensure the effectiveness of the summary, neutral and invalid comments are not analyzed by default.',
        'zh-CN': '为保证总结的有效性，我们默认会对所选数据进行两个处理：',
      },
      {
        'en-US': '',
        'zh-CN': '1. 去除中性评论（暂不支持）',
      },
      {
        'en-US': '',
        'zh-CN': '2. 去除被DataBrain判定为无效的评论',
      },
    ],
    mdFileMap: geminiAdvancedMdMap,
  },
];

const DeepseekSummaryDemoConfig = [
  {
    title: gptOptionsTextMap.basic,
    desc: [
      {
        'en-US':
          "Provides a quick and concise overview of opinions, summarizing the main positive and negative feedback points. This will help operations intuitively understand the players' attitudes.",
        'zh-CN':
          '提供快速且简洁的舆情概述，将总结出主要的正面和负面反馈要点，帮助运营直观获取玩家态度。',
      },
    ],
    mdFileMap: deepseekCommonMdMap,
  },
  {
    title: gptOptionsTextMap.advanced,
    desc: [
      {
        'en-US':
          'Provides detailed opinion summary on positive and negative player feedback, supplemented with specific data statistics. Each opinion will display the number of player comments and engagement data (such as likes).',
        'zh-CN':
          '提供正面、负面玩家反馈的详细观点，并附加具体的观点数据统计。每个观点都将展示玩家的具体评论数及互动数据（如点赞数）。',
      },
      {
        'en-US':
          'To ensure the effectiveness of the summary, neutral and invalid comments are not analyzed by default.',
        'zh-CN': '为保证总结的有效性，我们默认会对所选数据进行两个处理：',
      },
      {
        'en-US': '',
        'zh-CN': '1. 去除中性评论（暂不支持）',
      },
      {
        'en-US': '',
        'zh-CN': '2. 去除被DataBrain判定为无效的评论',
      },
    ],
    mdFileMap: deepseekAdvancedMdMap,
  },
];

const configMap: { [key in GPTType]: any } = {
  gpt: GPTSummaryDemoConfig,
  deepseek: DeepseekSummaryDemoConfig,
  gemini: geminiSummaryDemoConfig,
};

export default function GPTSummaryDemo() {
  const { formatMessage } = useLanguage();
  const la: LocaleType = getLocale();

  const tabs = useMemo(
    () =>
      AI_MODAL_OPTIONS.map(({ text, value }) => {
        return {
          id: value,
          label: (
            <div className="dbo-header-item">
              <img
                src={AiIconMap[value]}
                className="dbo-header-item-icon"
                alt={text}
              />
              {formatMessage({ id: text })}
            </div>
          ),
        };
      }),
    [formatMessage],
  );

  const { tab: activeId, onActive } = useTabHistory<GPTType>({
    defaultValue: DEFAULT_MODAL,
  });

  const config = useMemo(() => {
    return configMap[activeId];
  }, [activeId]);

  return (
    <Layout className="dbo-page criteria-wrapper">
      <Body>
        <Content>
          <ContentBody
            contentHeard={
              <Content.Header
                title={formatMessage({ id: 'AI Summary Demo' })}
                className="dbo-header"
              >
                {/* <div className="header-tab">
                  <Tabs
                    ceiling
                    tabs={tabs}
                    animated={false}
                    activeId={activeId}
                    onActive={onActive}
                  />
                </div> */}
              </Content.Header>
            }
          >
            {config.map(({ title, desc, mdFileMap }: any, index: number) => {
              return (
                <CardSlot className="dbo-summary-item" key={activeId + index}>
                  <div className="dbo-summary-item-header">
                    <h1 className="dbo-summary-item-title">
                      {formatMessage({ id: title })}
                    </h1>
                  </div>
                  {desc.map((item: any, index: number) => {
                    const text = item[la];
                    const isLast = index === desc.length - 1;
                    return (
                      <p
                        key={index}
                        className={`dbo-summary-item-desc ${
                          isLast ? 'dbo-desc-last' : ''
                        }`}
                      >
                        {text}
                      </p>
                    );
                  })}
                  <div key={activeId + index}>
                    <p className="dbo-summary-item-tips">
                      {formatMessage({ id: 'Demo:' })}
                    </p>
                    <MDShow mdFileMap={mdFileMap}></MDShow>
                  </div>
                </CardSlot>
              );
            })}
          </ContentBody>
        </Content>
      </Body>
    </Layout>
  );
}
